import React from 'react';
import ReactTable from 'react-table';
import Styled from 'styled-components';
import { Flex } from 'rebass';
import Badge from './Badge';
import TableHeader from './TableHeader';
import Cell from './Cell';
import { Headline } from '../FontStyles';
import Input from './Input';
import Button from './Button';
import IconButton from './IconButton';

// Overwriting a number of default styles for the default react table using existing classes
export const StyledTable = Styled(ReactTable)`
.-loading {
display:none;
}

.pagination-bottom {
  display: none;
  padding: ${props => props.theme.space[3]}px;
  justify-content: space-between;

  .-pagination {
    display: flex;
    width: 50%;
    margin: 0 auto;
    justify-content: space-between;

    .-center {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

      .-pageInfo {
        display: flex;
        width: 100%;
        justify-content: space-between;

      }
      .-pageSizeOptions {
        display: none;
      }
  }
}

.-sort-desc {
justify-content: space-between;
box-shadow: none !important;


i.down {

  color: ${props => props.theme.colors.mediumPurple};
}

}

.-sort-asc {
justify-content: space-between;
box-shadow: none !important;

i.up {
  color: ${props => props.theme.colors.mediumPurple};
}


}

width: 100%;


.rt-tr {
  display: flex;
  padding: 0 ${props => props.theme.space[3]};


}

.rt-th {
  &:hover{
  cursor: pointer;
}

&:focus{
    outline: none;
  }

display: flex;
padding:  ${props => props.theme.space[3]}px 0;
border-bottom: ${props => props.theme.border};
font-size: ${props => props.theme.fontSizes[4]}px;
font-family:  ${props => props.theme.font};
color: ${props => props.theme.colors.primaryFont};
line-height: 32px;
font-weight: 400;
}
`;

const TableTitleCont = Styled(Flex)`
border-bottom: ${props => props.theme.border};
`;

class Table extends React.Component {
  constructor() {
    super();
    this.state = {
      search: ''
    };
    this.removeRow = this.removeRow.bind(this);
  }

  removeRow(row) {
    let filteredData = this.props.data;
    filteredData.splice(row.index, 1);
    this.setState({ filteredData });
  }

  render() {
    let data = this.props.data;
    this.props.changeNavVisibility(false);

    if (this.state.search) {
      data = data.filter(row => {
        return (
          row['MRN'].toLowerCase().includes(this.state.search.toLowerCase()) ||
          row['follower Name'].toLowerCase().includes(this.state.search.toLowerCase()) ||
          row['time in range'].toLowerCase().includes(this.state.search.toLowerCase()) ||
          row['status'].toLowerCase().includes(this.state.search.toLowerCase()) ||
          row['Avg glucose'].toLowerCase().includes(this.state.search.toLowerCase())
        );
      });
    }

    return (
      <Flex flexWrap="wrap" mx="auto" width={0.9}>
        <TableTitleCont py={3} width={1} justifyContent="space-between" alignItems="center">
          <Flex alignItems="center">
            <Headline> {this.props.tableTitle ? this.props.tableTitle : 'Patient List'} </Headline>
            <Flex px={4}>
              <Button className="add-patient" to="/rxflow">
                Add new
              </Button>
            </Flex>
          </Flex>
          <Flex width={300}>
            <Input
              onChange={e => this.setState({ search: e.target.value })}
              placeholder="Search entries"
              width="100%"
            />
          </Flex>
        </TableTitleCont>
        <StyledTable
          data={data}
          minRows="0"
          defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
          columns={[
            {
              Header: () => <TableHeader>Name</TableHeader>,
              Cell: ({ value }) => (
                <Cell width={1} to={`/patients/012/daily`}>
                  {value}
                </Cell>
              ),
              id: 'name',
              filterMethod: (filter, row) => row[filter.value].includes(filter.value),
              Filter: ({ filter, onChange }) => (
                <Input
                  onChange={event => onChange(event.target.value)}
                  style={{ width: '100%' }}
                  value={filter ? filter.value : ''}
                />
              ),
              accessor: 'follower Name'
            },
            {
              Header: () => <TableHeader>MRN</TableHeader>,
              id: 'email address',
              Cell: ({ value }) => <Cell width={1}>{value}</Cell>,
              accessor: 'MRN'
            },
            {
              Header: () => <TableHeader>Last Upload</TableHeader>,
              Cell: ({ value }) => (
                <Cell>
                  <Badge m={0} bg={value === 'looping' ? '#6FCF97' : '#fff'}>
                    {value}
                  </Badge>
                </Cell>
              ),
              accessor: 'status'
            },
            {
              Header: () => <TableHeader> Average glucose</TableHeader>,
              accessor: 'Avg glucose',
              id: 'glucose',
              Cell: ({ row, value }) => <Cell>{value} mg/dL</Cell>
            },
            {
              Header: () => <TableHeader>Time in Range</TableHeader>,
              accessor: 'time in range',
              Cell: ({ value }) => <Cell width={1}>{value}%</Cell>
            },
            {
              Header: () => <Cell />,
              accessor: 'Avg glucose',
              id: 'dots',
              Cell: ({ row, value }) => (
                <Cell>
                  <Flex width="1" justifyContent="center" alignItems="center">
                    <IconButton row={row} removeRow={this.removeRow} />
                  </Flex>
                </Cell>
              )
            }
          ]}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </Flex>
    );
  }
}

export default Table;
